// src/lib/puzzles.js
// Tsume (詰将棋) mat problemleri + çözücü yardımcıları.
// Kurallar: her zaman SENTE (alttaki taraf) oynar ve her hamlede şah çekerek mat eder.
// solution: ana varyant, USI notasyonu (sente, gote, sente, ...).
// Tüm bulmacalar mat çözücüyle doğrulanmıştır (bkz. verifyPuzzle).

import { Shogi } from './ShogiEngine';

export const PUZZLES = [
  {
    id: "tsume-001",
    level: "easy",
    mateIn: 1,
    sfen: "4k4/9/4P4/9/9/9/9/9/K8 b G 1",
    solution: ["G*5b"],
    title: { tr: "Baş altını", en: "Head gold" },
    hint: {
      tr: "Elindeki altını şahın tam önüne at; piyade onu korur.",
      en: "Drop the gold right in front of the king; the pawn protects it.",
    },
  },
  {
    id: "tsume-002",
    level: "easy",
    mateIn: 1,
    sfen: "6r1k/8s/8B/9/9/9/9/9/K8 b S 1",
    solution: ["S*2b"],
    title: { tr: "Köşede gümüş", en: "Silver in the corner" },
    hint: {
      tr: "Gümüşü şahın çaprazına at; fil onu korur.",
      en: "Drop the silver diagonally next to the king; the bishop guards it.",
    },
  },
  {
    id: "tsume-003",
    level: "easy",
    mateIn: 1,
    sfen: "7nk/7bl/9/9/9/9/9/9/4K4 b N 1",
    solution: ["N*2c"],
    title: { tr: "İnde at", en: "Knight into the den" },
    hint: {
      tr: "Şahın kaçacak karesi yok; atın sıçrayışı yeter.",
      en: "The king has no flight squares; a knight jump is enough.",
    },
  },
  {
    id: "tsume-004",
    level: "easy",
    mateIn: 1,
    sfen: "7rk/9/7gS/6N2/9/9/9/9/K8 b L 1",
    solution: ["L*1b"],
    title: { tr: "Mızrakla kapanış", en: "Lance finish" },
    hint: {
      tr: "Mızrağı şahın hemen önüne at; gümüş korur, at da 2b karesini tutar.",
      en: "Drop the lance right in front of the king; the silver protects it and the knight covers 2b.",
    },
  },
  {
    id: "tsume-005",
    level: "easy",
    mateIn: 1,
    sfen: "1G2kr3/7R1/9/9/9/9/9/9/K8 b R 1",
    solution: ["R*7a"],
    title: { tr: "İki kale", en: "Two rooks" },
    hint: {
      tr: "İkinci kaleyi birinci sıraya at; diğer kale ikinci sırayı kesiyor.",
      en: "Drop the second rook on the back rank; the other rook already cuts off the second rank.",
    },
  },
  {
    id: "tsume-006",
    level: "easy",
    mateIn: 1,
    sfen: "3nkn3/3s1s3/4P4/9/9/9/9/4L4/8K b - 1",
    solution: ["5c5b+"],
    title: { tr: "Piyade sürerek mat", en: "Pawn push mate" },
    hint: {
      tr: "Piyade atarak mat yasaktır ama tahtadaki piyadeyi sürmek serbesttir. Mızrak arkadan korur.",
      en: "Mating with a dropped pawn is illegal, but pushing a pawn already on the board is fine. The lance guards it from behind.",
    },
  },
  {
    id: "tsume-007",
    level: "medium",
    mateIn: 3,
    sfen: "8k/7gr/6R2/9/9/9/9/9/K8 b N 1",
    solution: ["3c3a+", "2b2a", "N*2c"],
    title: { tr: "Ejderha ve at", en: "Dragon and knight" },
    hint: {
      tr: "Kaleyi terfi ettirerek yandan şah çek; araya giren altından sonra at işi bitirir.",
      en: "Promote the rook with a side check; after the gold interposes, the knight finishes.",
    },
  },
  {
    id: "tsume-008",
    level: "medium",
    mateIn: 3,
    sfen: "7gk/9/7S1/5S2+P/9/9/9/9/K8 b L 1",
    solution: ["L*1c", "2a1b", "2c1b+"],
    title: { tr: "Araya gireni al", en: "Take the interposer" },
    hint: {
      tr: "Mızrakla uzaktan şah çek; araya giren altını gümüşle terfi ederek al.",
      en: "Check from afar with the lance; capture the interposing gold with the silver and promote.",
    },
  },
  {
    id: "tsume-009",
    level: "medium",
    mateIn: 3,
    sfen: "6k2/9/6Br1/9/9/9/9/9/K8 b RG 1",
    solution: ["G*4b", "3a2a", "R*1a"],
    title: { tr: "Altınla it, kaleyle bitir", en: "Push with gold, finish with rook" },
    hint: {
      tr: "Önce altını şahın yanına at; şah kaçınca kaleyi birinci sıraya at.",
      en: "First drop the gold next to the king; when it runs, drop the rook on the back rank.",
    },
  },
  {
    id: "tsume-010",
    level: "medium",
    mateIn: 3,
    sfen: "3bkS3/6l2/2R6/9/9/9/9/9/K8 b R 1",
    solution: ["7c5c+", "5a4a", "R*5a"],
    title: { tr: "Merkezde ejderha", en: "Dragon in the centre" },
    hint: {
      tr: "Kaleyi 5c'de terfi ettirerek şah çek, sonra eldeki kaleyi şahın boşalttığı kareye at.",
      en: "Promote the rook on 5c with check, then drop the other rook on the square the king left.",
    },
  },
  {
    id: "tsume-011",
    level: "medium",
    mateIn: 3,
    sfen: "4kS3/9/2p3N2/9/9/9/9/9/K8 b RS 1",
    solution: ["R*5b", "5a6a", "S*7b"],
    title: { tr: "Burnuna kale", en: "Rook in the face" },
    hint: {
      tr: "Kaleyi şahın önüne at (gümüş korur); şah kaçınca gümüşü çaprazdan at.",
      en: "Drop the rook in front of the king (the silver guards it); when it flees, drop the silver diagonally.",
    },
  },
  {
    id: "tsume-012",
    level: "medium",
    mateIn: 3,
    sfen: "7k1/9/7G1/9/9/9/9/9/K8 b BN 1",
    solution: ["N*3c", "2a3a", "B*5c"],
    title: { tr: "At sürer, fil vurur", en: "Knight drives, bishop strikes" },
    hint: {
      tr: "Atı 3c'ye at ve şahı 3a'ya sür; ardından fili uzak köşegenden at.",
      en: "Drop the knight on 3c to drive the king to 3a, then drop the bishop on the long diagonal.",
    },
  },
  {
    id: "tsume-013",
    level: "hard",
    mateIn: 5,
    sfen: "6rk1/9/9/6G2/9/9/9/9/K8 b BGS 1",
    solution: ["S*1b", "2a3b", "B*4c", "3b4b", "G*5b"],
    title: { tr: "Şahı dışarı çek", en: "Drag the king out" },
    hint: {
      tr: "Gümüşle köşeden şah çek; şah merkeze kaçtıkça fil ve altınla kovala.",
      en: "Check from the corner with the silver; chase the king towards the centre with bishop and gold.",
    },
  },
  {
    id: "tsume-014",
    level: "hard",
    mateIn: 5,
    sfen: "8k/7P1/5G2p/8G/9/9/9/9/K8 b R 1",
    solution: ["R*3a", "1a2b", "4c3b", "2b1b", "3a2a+"],
    title: { tr: "Kale ile ağ", en: "Rook net" },
    hint: {
      tr: "Kaleyi 3a'ya at; şah kaçtıkça altınla yaklaş ve sonunda kaleyi terfi ettir.",
      en: "Drop the rook on 3a; follow the king with the gold and finally promote the rook.",
    },
  },
  {
    id: "tsume-015",
    level: "hard",
    mateIn: 5,
    sfen: "2sk5/2l6/9/5SN2/9/9/9/9/8K b RGS 1",
    solution: ["S*5b", "6a5b", "R*5c", "5b6b", "G*5b"],
    title: { tr: "Gümüş fedası", en: "Silver sacrifice" },
    hint: {
      tr: "Gümüşü 5b'ye feda et; şah alınca kaleyi önüne at.",
      en: "Sacrifice the silver on 5b; after the king takes, drop the rook in front of it.",
    },
  },
  {
    id: "tsume-016",
    level: "hard",
    mateIn: 5,
    sfen: "5G2k/9/9/6+R2/9/9/9/9/K8 b S 1",
    solution: ["3d1d", "1a2b", "S*2c", "2b3c", "1d3d"],
    title: { tr: "Ejderha dansı", en: "Dragon dance" },
    hint: {
      tr: "Ejderhayı 1d'ye çek, gümüşü at ve ejderhayla geri dön.",
      en: "Swing the dragon to 1d, drop the silver, then swing the dragon back.",
    },
  },
];

// ------------------------------------------------------------------ Çözücü (ve/veya arama)

const INF = 1 << 20;

// Saldıranın (sıradaki taraf) yasal ŞAH çeken hamleleri (iç kodlar).
function checkingMoves(e) {
  const side = e._stm;
  const list = e._gen(side, [], false);
  const out = [];
  for (let i = 0; i < list.length; i++) {
    const m = list[i];
    e._make(m, side);
    if (e._inCheck(-side) && e._wasLegal(m, side)) out.push(m);
    e._unmake();
  }
  return out;
}

class MateSolver {
  constructor(e) {
    this.e = e;
    this.memo = new Map();
    this.nodes = 0;
  }

  table(d) {
    let t = this.memo.get(d);
    if (!t) {
      t = new Map();
      this.memo.set(d, t);
    }
    return t;
  }

  // Saldıran sırada; en fazla d ply içinde zorla mat uzunluğu (ply) ya da INF.
  or(d) {
    if (d < 1) return INF;
    const e = this.e;
    const t = this.table(d);
    const k = e.hashKey();
    const hit = t.get(k);
    if (hit !== undefined) return hit;
    this.nodes++;
    const side = e._stm;
    let best = INF;
    const moves = checkingMoves(e);
    for (let i = 0; i < moves.length && best > 1; i++) {
      e._make(moves[i], side);
      const r = this.and(Math.min(d, best - 2) - 1);
      e._unmake();
      if (r < INF && r + 1 < best) best = r + 1;
    }
    t.set(k, best);
    return best;
  }

  // Savunan sırada; en uzun direnişte mata kalan ply (0 = zaten mat) ya da INF.
  and(d) {
    const e = this.e;
    const side = e._stm;
    const replies = e._legalList(side);
    if (replies.length === 0) return 0;
    if (d < 2) return INF;
    let worst = 0;
    for (let i = 0; i < replies.length; i++) {
      e._make(replies[i], side);
      const r = this.or(d - 1);
      e._unmake();
      if (r >= INF) return INF;
      if (r + 1 > worst) worst = r + 1;
    }
    return worst;
  }
}

// Sıradaki taraf (saldıran) için en kısa zorla mat uzunluğu (ply), maxPlies içinde; yoksa null.
export function solveMate(engine, maxPlies = 5) {
  const e = engine.clone();
  const s = new MateSolver(e);
  for (let d = 1; d <= maxPlies; d += 2) {
    const r = s.or(d);
    if (r < INF) return r;
  }
  return null;
}

// Savunan sırada: her yasal cevap için mata kalan ply (INF = mat yok, maxPlies içinde).
function replyDistances(engine, maxPlies) {
  const e = engine.clone();
  const s = new MateSolver(e);
  const side = e._stm;
  return e._legalList(side).map((m) => {
    e._make(m, side);
    let r = INF;
    for (let d = 1; d <= maxPlies; d += 2) {
      r = s.or(d);
      if (r < INF) break;
    }
    e._unmake();
    return { code: m, dist: r };
  });
}

// En uzun direnen yasal cevap (gote). Eşitlikte: taş almayan/atmayan hamle yerine
// önce şahla kaçış, sonra taş alma; araya boşuna taş atma (muda-ai) en sona.
export function defenderReply(engine, { maxPlies = 7 } = {}) {
  const list = replyDistances(engine, maxPlies);
  if (!list.length) return null;
  const B = engine._sq;
  const rank = (m) => {
    const from = m & 127;
    if (from >= 81) return 0; // atma
    const p = B[from];
    if (p === 8 || p === -8) return 3; // şah kaçışı
    return B[(m >> 7) & 127] !== 0 ? 2 : 1;
  };
  list.sort((a, b) => b.dist - a.dist || rank(b.code) - rank(a.code));
  return engine.descriptorFromCode(list[0].code);
}

// ------------------------------------------------------------------ Bulmaca yardımcıları

export function getPuzzle(id) {
  return PUZZLES.find((p) => p.id === id) || null;
}

const sameDescriptor = (a, b) => {
  if (!a || !b || a.kind !== b.kind) return false;
  if (a.to.row !== b.to.row || a.to.col !== b.to.col) return false;
  if (a.kind === 'drop') return (a.pieceType || a.type) === (b.pieceType || b.type);
  return a.from.row === b.from.row && a.from.col === b.from.col && !!a.promote === !!b.promote;
};

// engine: hamle ÖNCESİ pozisyon (sente sırada). ply: solution dizisindeki indeks.
// Dönüş: 'wrong' | 'correct' | 'solved'. engine değiştirilmez.
export function checkPuzzleMove(puzzle, engine, ply, descriptor) {
  if (!puzzle || !engine.isLegal(descriptor)) return 'wrong';
  const e = engine.clone();
  e.applyDescriptor(descriptor);
  if (e.isCheckmate()) return 'solved'; // herhangi bir yasal mat hamlesi kabul
  if (!e.isCheck()) return 'wrong'; // tsume: her hamle şah olmalı
  const remaining = puzzle.solution.length - ply - 1; // bu hamleden sonra kalan ply
  if (remaining <= 0) return 'wrong';
  const expected = Shogi.parseUsi(puzzle.solution[ply]);
  if (sameDescriptor(expected, { ...descriptor, promote: !!descriptor.promote })) return 'correct';
  // alternatif: kalan hamle sayısı içinde zorla mat varsa kabul et
  const s = new MateSolver(e);
  return s.and(remaining) < INF ? 'correct' : 'wrong';
}

// Gote'nin cevabı: oyuncu ana varyantta ise solution'daki hamle, değilse en uzun direniş.
// ply: gote hamlesinin solution indeksi (1, 3, ...).
export function puzzleReply(puzzle, engine, ply) {
  const main = mainLinePosition(puzzle, ply);
  if (main && main === positionKey(engine) && puzzle.solution[ply]) {
    const d = Shogi.parseUsi(puzzle.solution[ply]);
    if (engine.isLegal(d)) return d;
  }
  return defenderReply(engine, { maxPlies: Math.max(1, puzzle.solution.length - ply) });
}

const positionKey = (engine) => engine.toSfen().split(' ').slice(0, 3).join(' ');

function mainLinePosition(puzzle, ply) {
  try {
    const e = Shogi.fromSfen(puzzle.sfen);
    for (let i = 0; i < ply; i++) e.applyDescriptor(Shogi.parseUsi(puzzle.solution[i]));
    return positionKey(e);
  } catch (err) {
    return null;
  }
}

// Bulmacayı çözücüyle tam doğrular. { ok, errors[], info }
export function verifyPuzzle(puzzle) {
  const errors = [];
  const info = { uniqueFirst: null, attackerAlternatives: [], defenderTies: [] };
  let e;
  try {
    e = Shogi.fromSfen(puzzle.sfen);
  } catch (err) {
    return { ok: false, errors: ['SFEN: ' + err.message], info };
  }
  if (e._king[0] < 0 || e._king[1] < 0) errors.push('iki şah yok');
  if (e.turn() !== 'sente') errors.push('sıra sente değil');
  if (e.isCheck('gote')) errors.push('gote başlangıçta şahta');
  if (e.isCheck('sente')) errors.push('sente başlangıçta şahta');
  // mateIn tsume geleneğindeki gibi ply sayısıdır (3 = sente, gote, sente)
  if (puzzle.solution.length !== puzzle.mateIn) errors.push('solution uzunluğu mateIn ile uyuşmuyor');
  const plies = puzzle.mateIn;
  const shortest = solveMate(e, plies);
  if (shortest == null) errors.push(`${plies} hamlede zorla mat yok`);
  else if (shortest < plies) errors.push(`daha kısa mat var (${shortest} hamle)`);
  for (let i = 0; i < puzzle.solution.length; i++) {
    const d = Shogi.parseUsi(puzzle.solution[i]);
    if (!d || !e.isLegal(d)) {
      errors.push(`hamle ${i + 1} (${puzzle.solution[i]}) yasal değil`);
      break;
    }
    const remaining = plies - i;
    if (i % 2 === 0) {
      // saldıran: kaç alternatif şah hamlesi kalan sürede mat ediyor?
      const alts = [];
      const side = e._stm;
      for (const m of checkingMoves(e)) {
        e._make(m, side);
        const s = new MateSolver(e);
        const r = s.and(remaining - 1);
        e._unmake();
        if (r < INF) alts.push(e.toUsi(e.descriptorFromCode(m)));
      }
      info.attackerAlternatives.push(alts.length);
      if (i === 0) info.uniqueFirst = alts.length === 1;
      if (!alts.includes(puzzle.solution[i])) errors.push(`hamle ${i + 1} zorla mata götürmüyor`);
    } else {
      const dists = replyDistances(e, remaining);
      const max = Math.max(...dists.map((x) => x.dist));
      const mine = dists.find((x) => e.toUsi(e.descriptorFromCode(x.code)) === puzzle.solution[i]);
      if (!mine || mine.dist !== max) errors.push(`gote hamlesi ${i + 1} en uzun direniş değil`);
      info.defenderTies.push(dists.filter((x) => x.dist === max).length);
    }
    e.applyDescriptor(d);
    if (i % 2 === 0 && !e.isCheck()) errors.push(`hamle ${i + 1} şah değil`);
  }
  if (!errors.length && !e.isCheckmate()) errors.push('son pozisyon mat değil');
  return { ok: errors.length === 0, errors, info };
}
